export default __webpack_public_path__ + "static/media/resp-gaming.65e637f7.svg";